/* eslint-disable react/no-array-index-key */
import { List, ListItem, ListItemIcon, ListItemText, makeStyles, } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
export const useStyles = makeStyles((theme) => ({
    list: { width: '100%', overflowX: 'hidden' },
    itemWrapper: {
        height: '48px',
        margin: theme.spacing(2, 0),
        justifyContent: ({ collapsed }) => (collapsed ? 'center' : 'flex-start'),
    },
    itemWrapperSelected: {
        backgroundColor: theme.palette.primary.contrastText,
        '&:hover': {},
    },
    icon: {
        fill: theme.palette.text.secondary,
        minWidth: ({ collapsed }) => (collapsed ? 'unset' : '40px'),
        '& svg': {
            width: '20px',
            height: '20px',
        },
    },
    iconSelected: {
        '& svg': {
            fill: theme.palette.primary.dark,
        },
    },
    text: {
        color: theme.palette.text.secondary,
        '& span': {
            fontSize: '16px',
            fontWeight: 500,
        },
    },
    textSelected: {
        color: theme.palette.primary.dark,
    },
}));
const NavList = ({ links, classes = {}, collapsed, navigateToUrl, }) => {
    const baseClasses = useStyles({ collapsed });
    const allClasses = mergeClasses({
        baseClasses,
        newClasses: classes,
        Component: NavList,
    });
    return (React.createElement(List, { component: 'nav', className: allClasses.list }, links.map(({ icon, link, name, selected }, index) => (React.createElement(ListItem, Object.assign({ key: `list-item-${index}`, button: true, className: clsx(allClasses.itemWrapper, {
            [allClasses.itemWrapperSelected]: !!selected,
        }) }, (link ? { onClick: () => navigateToUrl(link) } : {})),
        icon && (React.createElement(ListItemIcon, { key: `list-item-icon-${index}`, className: clsx(allClasses.icon, {
                [allClasses.iconSelected]: !!selected,
            }) }, icon)),
        name && !collapsed && (React.createElement(ListItemText, { key: `list-item-text-${index}`, className: clsx(allClasses.text, {
                [allClasses.textSelected]: !!selected,
            }) }, name)))))));
};
export default NavList;
